import { useCallback, useEffect, useState } from 'react';

import { MAX_MOBILE_VIEW, MAX_TABLET_VIEW } from '../screenConstants';
import { useWindowSize } from './useWindowSize';

export const useMobileDetect = () => {
  const { width } = useWindowSize();

  const getIsMobile = useCallback((width: number) => {
    const calcMobile = !!(width && width <= MAX_MOBILE_VIEW);
    return Boolean(calcMobile).valueOf();
  }, []);

  const getIsTablet = useCallback((width: number) => {
    const calcTablet = !!(width && width <= MAX_TABLET_VIEW);
    return Boolean(calcTablet).valueOf();
  }, []);

  const [mobileInit, setMobile] = useState<boolean>(getIsMobile(width));
  const [tabletInit, setTablet] = useState<boolean>(getIsTablet(width));

  useEffect(() => {
    const calcMobile = getIsMobile(width);
    setMobile(calcMobile);
    const calcTablet = getIsTablet(width);
    setTablet(calcTablet);
  }, [getIsMobile, getIsTablet, width]);

  return {
    isMobile: mobileInit,
    isTablet: tabletInit && !mobileInit
  };
};
